import { useCallback, useRef } from 'react';
import type { FlatListProps } from 'react-native';
import type { OutfitEntity } from '../types';
import { bridge } from '../../../../../utils';

// iOS MetaFeedOutfitCell: DISPLAY_CONTENT (셀 50% 이상 노출 시)
export const useLogDisplayContent = () => {
  const loggedList = useRef<Array<number>>([]);

  const logDisplayContent = useCallback<
    NonNullable<FlatListProps<OutfitEntity>['onViewableItemsChanged']>
  >(({ viewableItems }) => {
    viewableItems.forEach(({ index, isViewable, item }) => {
      if (index === null || !isViewable) {
        return;
      }
      if (loggedList.current.includes(index)) {
        return;
      }
      loggedList.current.push(index);

      bridge.logAnalyticsEvent({
        name: 'DISPLAY_CONTENT',
        analytics: item.logging.analytics,
        ably_only_log: item.logging.ably_only_log,
      });
    });
  }, []);

  return { logDisplayContent };
};